import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import map from "lodash/map"
import keyBy from "lodash/keyBy"
import { TOIR_SERVICE_URL, PASSPORT_REFERENCE_URL } from "./constants"
import commonApiAuthRequest from "../apiAuthRequest"
import { visitsFetch } from "./visits"

/*
  Спека
  https://next.stoplight.io/infotech-group/toir/version%2F1.0/inspection-service.oas2.yml?view=%2Freference%2Fplanned-defect-list%2Ffindplanneddefectlists
  https://next.stoplight.io/infotech-group/toir/version%2F1.0/inspection-service.oas2.yml?view=%2Freference%2Fdefect%2Ffinddefectmodels
*/

const plannedDefectsFetch = issueId =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/planned-defect-list`,
    params: { query: `issueId=in=(${issueId})` },
  })

const defectsByIdsFetch = defectsIds =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/defect`,
    params: { limit: -1, query: `id=in=(${defectsIds})` },
  })

const defectTypeFetch = typeCode =>
  commonApiAuthRequest({
    url: `${PASSPORT_REFERENCE_URL}/objects/data/rowByKey/defect_type_toro/v1/${typeCode}`,
    params: {},
  })

const defectsByVisitIdsFetch = visitIds =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/defect`,
    params: { limit: -1, query: `visitId=in=(${visitIds})` },
  })

/**
 * makes a couple of requests to get defect list by issueId
 *
 * @param {number} issueId
 * @return {Array.<Object>} response - array of defects
 */
export const getDefectsPlanned = async issueId => {
  if (!issueId) {
    return undefined
  }

  const {
    data: [plannedDefectList],
  } = await plannedDefectsFetch(issueId)

  const defectsIds = get(plannedDefectList, `defects`)

  if (isEmpty(defectsIds)) {
    return []
  }

  const { data: defects } = await defectsByIdsFetch(defectsIds)
  const defectTypesCodes = map(defects, `typeCode`)
  const defectTypesResponse = await Promise.all(
    map(defectTypesCodes, payload => defectTypeFetch(payload)),
  )
  const defectTypesInfo = keyBy(map(defectTypesResponse, `data`), `code`)
  const preparedDefects = map(defects, defect => ({
    ...defect,
    defectTypeName: get(defectTypesInfo, [defect.typeCode, `name`]),
  }))

  return preparedDefects
}

/**
 * makes a couple of requests to get defect list by issueId
 *
 * @param {number} issueId
 * @return {Array.<Object>} response - array of defects
 */
export const getDefectsByVisit = async issueId => {
  if (!issueId) {
    return undefined
  }

  const { data: visits } = await visitsFetch(issueId)

  const visitsIds = map(visits, `id`)

  if (isEmpty(visitsIds)) {
    return []
  }

  const { data: defects } = await defectsByVisitIdsFetch(visitsIds)
  const defectTypesCodes = map(defects, `typeCode`)
  const defectTypesResponse = await Promise.all(
    map(defectTypesCodes, payload => defectTypeFetch(payload)),
  )
  const defectTypesInfo = keyBy(map(defectTypesResponse, `data`), `code`)
  const preparedDefects = map(defects, defect => ({
    ...defect,
    defectTypeName: get(defectTypesInfo, [defect.typeCode, `name`]),
  }))

  return preparedDefects
}
